import { Tooltip } from "@msuite/ui/tooltip";
import { cn } from "@msuite/ui/utils";
import { Holidays } from "@msuite/utils/holidays";
import { memo } from "react";
import type { CapacityCalendarCell } from "./use-capacity-calendar";

/** Props Interface */
interface CapacityCalendarHeaderItemProps {
	cell: CapacityCalendarCell;
}

function CapacityCalendarHeaderItemImpl({ cell }: CapacityCalendarHeaderItemProps) {
	const { cellMoment, isWeekend, isHoliday, isToday } = cell;

	/** Render */
	return (
		<div
			className={cn(
				"v-stack w-full h-full flex-center gap-0 items-center *:text-xs",
				isWeekend && "bg-gray-100 dark:bg-zinc-800",
				isHoliday && "stripes",
			)}
		>
			<Tooltip
				label={Holidays.getHolidayByDate(cellMoment.db(), "BE")?.translate("de")}
				isDisabled={!isHoliday}
				className="flex-center flex-col w-full h-full cursor-pointer"
			>
				<p className={cn(isHoliday && "text-red-500!")}>{cellMoment.format("dd")}</p>
				<p
					className={cn(
						"size-5 rounded-full flex items-center justify-center",
						isHoliday && "text-red-500!",
						isToday && "bg-accent-500! text-white!",
					)}
				>
					{cellMoment.format("DD")}
				</p>
			</Tooltip>
		</div>
	);
}

export const CapacityCalendarHeaderItem = memo(CapacityCalendarHeaderItemImpl);
